module.exports = __webpack_public_path__ + "img/phone.e5d4b1e8.svg";